"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ark = require("@dateam/ark");
var _TableCell = _interopRequireDefault(require("./TableCell"));
var _ColumnCheckbox = _interopRequireDefault(require("./ColumnCheckbox"));
// import propTypes from 'prop-types';

const TableRow = _ref => {
  let {
    data,
    columns,
    selectedField,
    onClick,
    onSelectionChange
  } = _ref;
  const handleRowClick = _react.default.useCallback(event => {
    const {
      target
    } = event;
    const {
      cellIndex
    } = target;
    if ((0, _ark.isFunction)(onClick)) {
      onClick(cellIndex);
    }
  }, [onClick]);
  const handleRowSelectionChange = _react.default.useCallback((selected, event) => {
    if ((0, _ark.isFunction)(onSelectionChange)) {
      onSelectionChange(selected);
    }
  }, [onSelectionChange]);
  const handleRowSelectionClick = event => {
    event.stopPropagation();
  };
  const columnChildren = _react.default.useMemo(() => {
    const cells = [];
    if ((0, _ark.isString)(selectedField)) {
      const isSelected = (0, _ark.getPropertySafe)(data, selectedField) === true;
      cells.push( /*#__PURE__*/_react.default.createElement("td", {
        key: 0,
        className: "tableCol",
        onClick: handleRowSelectionClick
      }, /*#__PURE__*/_react.default.createElement(_ColumnCheckbox.default, {
        checked: isSelected,
        onChange: handleRowSelectionChange
      })));
    }
    columns.forEach((column, columnIdx) => {
      cells.push( /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        key: columnIdx + 1,
        data: data,
        column: column
      }));
    });
    return cells;
  }, [data, columns, selectedField, handleRowSelectionChange]);
  return /*#__PURE__*/_react.default.createElement("tr", {
    className: "tableRow",
    onClick: handleRowClick
  }, columnChildren);
};

// TableRow.propTypes = {
//     data: propTypes.any.isRequired,
//     columns: propTypes.arrayOf(propTypes.any).isRequired,
//     selectedField: propTypes.string,
//     onClick: propTypes.func,
//     onSelectionChange: propTypes.func
// };

// TableRow.defaultProps = {
//     selectedField: undefined,
//     onClick: undefined,
//     onSelectionChange: undefined
// };
var _default = exports.default = TableRow;